import st from '../../pages/testimonals/index.module.css';
import React, { useEffect, useState } from 'react';

const Review = props => {
  const [image, setImg] = useState(null);
  const getImage = () => {
    switch (props.data.category) {
      case 'video':
        setImg('https://admin.weprodigi.com/uploads/images/testimonals/video.svg');
        break;
      case 'smm':
        setImg('https://admin.weprodigi.com/uploads/images/testimonals/smm.svg');
        break;
      case 'design':
        setImg('https://admin.weprodigi.com/uploads/images/testimonals/design.svg');
        break;
      case 'paidAds':
        setImg('https://admin.weprodigi.com/uploads/images/testimonals/paidAds.svg');
        break;
      default:
        setImg('https://admin.weprodigi.com/uploads/images/testimonals/video.svg');
    }
  };
  useEffect(() => {
    getImage();
  }, [props.data]);

  return (
    <div className={' w-full rounded-5 py-24 flex flex-col justify-between px-31 ' + st['my-shadow']}>
      <div>
        <p className={'mt-16 leading-20 text-16'}>
          <img src={image} className={'float-left mr-10 '} width={25} height={15} alt="review1" />
          {props.data.text}
        </p>
      </div>
      <div className={'flex items-center justify-between mt-21'}>
        <div className={'flex justify-start items-start w-80p'}>
          <img src={'https://admin.weprodigi.com' + props.data.image} width={44} height={44} className={'rounded-full review-img'} alt="review1" />
          <div className={'ml-24'}>
            <p className={'text-black text-16 font-400'}>{props.data.name}</p>
            <p className={'text-14 max-w-150 md:max-w-none md:text-16 font-400 leading-15 text-purple capitalize'}>
              {props.data.position}, {props.data.company}
            </p>
          </div>
        </div>
        <a
          aria-label="review"
          href={props.data.review_url}
          target={'_blank'}
          className={'flex font-medium justify-start text-12 leading-15 text-green w-20p'}
        >
          Read Review
          <svg xmlns="http://www.w3.org/2000/svg" className={''} width={15} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </a>
      </div>
    </div>
  );
};
export default Review;
